// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7cdc0bac","516":"2d3c4b90","647":"73077535","781":"16da8c2a","814":"d66386d6","861":"fe9f96a6","981":"4774af33"}[chunkId] + ".chunk.js";
};